import { render, staticRenderFns } from "./AllocationReportSharedPoolSteps.vue?vue&type=template&id=4c7fc1b3"
import script from "./AllocationReportSharedPoolSteps.vue?vue&type=script&lang=js"
export * from "./AllocationReportSharedPoolSteps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports